/**
 * Copyright (c) 2026, CYBRA Corp. All rights reserved.
 */
import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { PvhScanChamberService, PvhScanChamberStateInfoDto } from "app/services/pvh.scan-chamber.service";

/**
 * Resolves the State for the PVH Scan Chamber whose ID is in the "id" parameter
 * in the page path. 
 */
@Injectable()
export class PvhScanChamberStateResolver implements Resolve<PvhScanChamberStateInfoDto | null> {

  /** Constructor */
  constructor(
    private pvhService: PvhScanChamberService
  ) {}

  /** Obtains the data to be resolved in the background. */
  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<PvhScanChamberStateInfoDto | null> {
    // Get the 'ID' Path parameter which is the ID of the Scan Chamber to obtain...
    const id = route.paramMap.get('id');    
    if (id == null || id.length == 0) {
      return null;
    }

    // Call the API to retrieve the current state for the Scan Chamber with the given ID
    return await this.pvhService.getState(id);
  }

}
